<template>
  <v-layout>
    <d-header
      fluid
      :actions="actions"
    >
      <h1 class="title">
        {{ $t("properties") }}
      </h1>
    </d-header>

    <v-property-list
      ref="propertyList"
    />

    <v-create-modal
      v-if="isCreatePropertyModalOpen"
      :is-shown="isCreatePropertyModalOpen"
      @close="isCreatePropertyModalOpen = false"
    />
  </v-layout>
</template>

<script>
import list from "./_list.vue";
import QueryString from "qs";
import CreatePropertyModal from "./_modal_create.vue";

export default {
  components: {
    "v-property-list": list,
    "v-create-modal": CreatePropertyModal,
  },
  metaInfo() {
    return {
      title: this.$t("properties").capitalize(),
    };
  },
  data(){
    return {
      isReady: false,
      isCreatePropertyModalOpen: false,
    };
  },
  computed: {
    actions() {

      let query = "";

      if (this.lisParametres) {
        query = "?" + this.lisParametres;
      }

      return [
        {
          label: this.$t("export"),
          path: window.Laravel.app.url + "/api/properties/export"+query,
          resource: "property",
          method:"export",
          primary: true,
          color: "is-secondary",
          download:true,
        },
        {
          label: this.$t("new_property"),
          primary: true,
          color: "is-primary",
          resource: "property",
          action: this.openCreatePropertyModal
        },
      ];
    },
    lisParametres() {

      if (this.isReady) {

        const lisParametres = this.$refs.propertyList.dataTableParameters;

        return QueryString.stringify(lisParametres);

      }

      return null;
    },
  },
  mounted() {
    this.isReady = true;
  },
  methods: {
    openCreatePropertyModal() {
      this.isCreatePropertyModalOpen = true;
    },
  },
};
</script>


